import type { ChangeEvent } from "react";
import { useInput } from "react-admin";
import { Box, Button, Stack, TextField as MuiTextField, Typography } from "@mui/material";

const isImage = (v: string) => /^(data:|https?:)/i.test(v);

// Логотип банка: картинка (data-URI) или Unicode-эмодзи. Загрузка файла читается в base64
// data-URI и кладётся в то же строковое поле logo. Можно и вручную вставить эмодзи/URI.
export function LogoInput() {
  const { field } = useInput({ source: "logo" });
  const value: string = field.value ?? "";

  const onFile = (e: ChangeEvent<HTMLInputElement>) => {
    const f = e.target.files?.[0];
    if (!f) return;
    const reader = new FileReader();
    reader.onload = () => field.onChange(reader.result as string);
    reader.readAsDataURL(f);
    e.target.value = "";
  };

  return (
    <Stack spacing={1} sx={{ my: 1, width: "100%", maxWidth: 520 }}>
      <Typography variant="caption" color="text.secondary">
        Логотип (картинка или эмодзи)
      </Typography>
      <Stack direction="row" spacing={2} alignItems="center">
        <Box
          sx={{
            width: 44,
            height: 44,
            borderRadius: 2,
            bgcolor: "action.hover",
            display: "grid",
            placeItems: "center",
            overflow: "hidden",
            fontSize: 24,
            flexShrink: 0,
          }}
        >
          {value ? (
            isImage(value) ? (
              <img src={value} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            ) : (
              value
            )
          ) : (
            "—"
          )}
        </Box>
        <Button variant="outlined" component="label" size="small">
          Загрузить картинку
          <input type="file" accept="image/*" hidden onChange={onFile} />
        </Button>
        {value && (
          <Button size="small" color="inherit" onClick={() => field.onChange("")}>
            Очистить
          </Button>
        )}
      </Stack>
      <MuiTextField
        label="logo (эмодзи или data-URI)"
        value={value}
        onChange={(e) => field.onChange(e.target.value)}
        size="small"
        fullWidth
        multiline
        maxRows={3}
        helperText="Вставьте эмодзи (🏦) или загрузите картинку — реальный логотип банка."
      />
    </Stack>
  );
}
